import * as types from './types';

// Note: isAuthStateLoading has been moved to the auth slice (state.auth.isLoading)
export const initialState = {
  message: null,
  i18n: null,
  isAppLoading: false,
  isDemoMode: false,
  isBillingLive: true, // Enable billing operations by default
  loadingModules: {}
};

const commonReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_SNACK_MESSAGE:
      return {
        ...state,
        message: action.payload
      };
    case types.CLEAR_SNACK_MESSAGE:
      return {
        ...state,
        message: null
      };
    case types.SET_I18N:
      return {
        ...state,
        i18n: action.payload
      };
    case types.SET_IS_APP_LOADING:
      return {
        ...state,
        isAppLoading: action.payload
      };
    case types.SET_IS_DEMO_MODE:
      return {
        ...state,
        isDemoMode: action.payload
      };
    case types.SET_LOADING_MODULE:
      return {
        ...state,
        loadingModules: {
          ...state.loadingModules,
          ...action.payload
        }
      };
    // SET_AUTH_STATE_LOADING removed - now handled by auth slice
    case types.SET_IS_BILLING_LIVE:
      return {
        ...state,
        isBillingLive: action.payload
      };
    default:
      return state;
  }
};

export default commonReducer;